<!-- eslint-disable -->
<template>
  <div class=" w-50 m-width text-14 container">
    <section id="header" class="desktop-header fixed-top  w-50 m-width text-14 container">
      <div>
        <b-navbar class="bg-white" toggleable="lg" type="dark" style="padding-left:0px !important;padding-right:0px !important;">
          <b-navbar-brand style="display: inline-flex;align-items: center;width: 100%;justify-content:space-between">
            <span id="back-userapp" @click="backToUA()" style="display: inline-flex;text-align: center;">
              <img src="@/assets/images/arrow_left.svg" alt="Back" />
              <div class="header-title" v-if="showHeaderTitle" style="display: inline-flex;align-items: center;width: 100%;justify-content:space-between">{{ headerTitle }} </div>
            </span>
            <div v-if="showShareButton" @click="shareOrderFunc()">
              <img src="@/assets/images/ic_share.svg" alt="Paxel" />
            </div>
          </b-navbar-brand>
        </b-navbar>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import LocalStorage from '@/services/localstorage';

export default {
  name: 'HeaderNav',
  data() {
    return {
      showHeaderTitle: false,
      showShareButton: false,
      status:"",
      shareData : null,
      headerTitle:""
    };
  },
  computed :{
    orderStatus(){
      return this.$store.state.orderStatus 
    },
    language() {
      return this.$store.state.language;
    },
  },
  watch : {
    orderStatus(val){
      if(val == 'CUSTOMER_TAKEN' || val == 'TAKEN_BY_SYSTEM' || val == 'OPERATOR_PICK' || val == 'OPERATOR_TAKEN' || val == 'CANCEL' || val == 'CUSTOMER_STORE'){
        this.showShareButton = true;
      }
    },
    $route(route) {
      this.changeHeaderTitle(route)
    },
  },
  mounted(){
    this.changeHeaderTitle(this.$route)
    window.backDeviceUA = this.backToUA
  },
  methods: {
    backToUA() {
      if(this.$store.getters.getOrderDetail){
        let netcorePayload = this.generalEventPayloadData(true);
        this.recordEvent('Back_Button_on_Rent_PaxelBox', netcorePayload) 
      }
      if (typeof MobileJS != "undefined") {
        MobileJS.closePaxelWebview();
      } else if (typeof webkit != "undefined") {
        try {
          webkit.messageHandlers.closePaxelWebview.postMessage(
            "closePaxelWebview"
          );
        } catch (err) {
          console.log("The native context does not exist yet");
        }
      } else {
        this.$router.go("-1");
      }
    },
    shareOrderFunc(){
      let order = this.$store.state.orderDetail; 
      if(order == null){
        order = LocalStorage.getOrderData();
        order = JSON.parse(order)
      }
      if(order){
        if(order.status == 'CUSTOMER_TAKEN' || order.status == 'TAKEN_BY_SYSTEM' || order.status == 'OPERATOR_PICK' || order.status == 'OPERATOR_TAKEN' || order.status == 'CANCEL'){
          this.showShareButton = true;
          let displayStatus = this.getStatusDisplayName(order.status)
          this.shareData = {
            recipientName : order.recipientName,
            expressNumber : order.expressNumber,
            box : {
              address : order.mouth.box.address,
              name:order.mouth.box.name,
            },
            paymentInfo : [],
            status :displayStatus.text,
          }

          let payOfAmount = 
          {
            "value" : this.formatRupiah(order.payOfAmount),
            "label" : this.language == 'en'?'Rent Fee':'Biaya Sewa',
            "key" : "payOfAmount",
            "style" : ""
          }
          this.shareData.paymentInfo.push(payOfAmount)
          
          if (order.total_donation > 0){
            order.donation.forEach(donate => {
              let donation = {
                "value" : this.formatRupiah(donate.sub_total),
                "label" : `${donate.qty} item | ${this.language == "en" ? donate.name.en : donate.name.id}`,
                "key" : "donation",
                "style" : ""
              }
              this.shareData.paymentInfo.push(donation)
            });
          }
          
          let adminFee = {
            "value" : this.formatRupiah(order.admin_fee?.total_amount ?? 0),
            "label" : this.language == 'en'?'Admin Fee':'Biaya Admin',
            "key" : "adminFee",
            "style" : ""
          }
          this.shareData.paymentInfo.push(adminFee)

          let total = {
            "value" : this.formatRupiah(order.payOfAmount ?? 0 + order.admin_fee?.total_amount ?? 0 + order.total_donation ?? 0),
            "label" : this.language == 'en'?'Total Payment':'Total Pembayaran',
            "key" : "totalPayment",
            "style" : "bold"
          }
          this.shareData.paymentInfo.push(total)

          let paymentMethod = {
            "value" :order.paymentMethod,
            "label" : this.language == 'en'?'Payment Method':'Metode Pembayaran',
            "key" : "paymentMethod",
            "style" : ""
          }
          this.shareData.paymentInfo.push(paymentMethod)
        }
        this.buttonSyncShareOrder(this.shareData)
      }
    },
    changeHeaderTitle(route){
      if(route.name == 'order'){
        this.showHeaderTitle = true;
        this.showShareButton = false;
        this.headerTitle = (this.language == 'en') ? 'Order Detail' : 'Detail Order'
      }else if(route.name == 'overdue'){
        this.showHeaderTitle = false;
      }else if(route.name == 'order-status' && route.query.status == 'overdue'){
        this.showHeaderTitle = true;
        this.headerTitle = (this.language == 'en') ? 'Overdue fee' : 'Biaya Perpanjang Sewa'
      }else{
        this.showHeaderTitle = false;
        this.showShareButton = false;
      }
    }
  },
};
</script>

<style>
.header-title {
  margin-left: 40px;
  text-align: center;
  align-items: center;
  color: #424143;
  font-size: 16px;
  font-weight: bold;
}
</style>
